import React from 'react'
import { Tag } from 'antd'
import { TAGS, TRUTHY, FALSY } from 'constant/tags'
import _ from 'lodash'
import styles from './styles'

const StatusTags = (props) => {
  return (
    <div className={styles.tag_wrapper}>
      {_.map(props, (tagValue, tagType) => {
        const tag = TAGS[tagType][tagValue ? TRUTHY : FALSY]

        return tag &&
          <Tag
            className={styles.tag}
            color={tag.colour}
            key={tagType}
          >
            {tag.text}
          </Tag>
      })}
    </div>
  )
}

export default StatusTags
